import React, { FC } from 'react';
import BEMHelper from 'react-bem-helper';
import '../../common/fonts.less';
import './style.less';
import Icon from '../Icon';

const classes = new BEMHelper('Launcher');

type LauncherProps = {
    className?: string;
    children?: React.ReactNode;
    Logo: React.FC;
    image?: React.ReactNode;
    afterElement?: React.ReactNode;
};

const Launcher: FC<LauncherProps> = ({
    className,
    children,
    Logo,
    image = null,
    afterElement = null,
}) => (
        <div {...classes('', '', className)}>
            <div {...classes('header')}>
                <Logo />
            </div>

            <div {...classes('main')}>
                {children}
                {image || (
                    <div className='image'>
                        <Icon name='welcome' />
                    </div>
                )}
                {afterElement}
            </div>
        </div>
    );

export default Launcher;
